import { IRestaurantArea, IRestaurantVirtualArea, Pill, SectionLabel } from '@localina/core';
import AutoStoriesTwoToneIcon from '@mui/icons-material/AutoStoriesTwoTone';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHaveAccountFeatures } from '../../../api/queries/account';
import { useVirtualAreas } from '../../../api/queries/restaurantAreas';
import VirtualAreaView from './VirtualAreaView';

const VirtualAreas: React.FC = () => {
    const { t } = useTranslation();
    const virtualAreasQuery = useVirtualAreas();
    const [selectedVirtualArea, setSelectedVirtualArea] = useState<IRestaurantVirtualArea | undefined>(undefined);
    const [canEditAreas] = useHaveAccountFeatures(['areasEdit']);

    const onVirtualAreaViewClose = () => {
        setSelectedVirtualArea(undefined);
    };

    return (
        <div className="restaurant-sectors-main-areas">
            <SectionLabel value={t('sectors.mainAreas')} />
            <div className="main-area-cards">
                {virtualAreasQuery.isSuccess &&
                    virtualAreasQuery.data.virtualAreas.map((virtualArea) => {
                        const seats = virtualArea.areas.reduce((total, area) => total + (area.capacity || 0), 0);
                        return (
                            <div
                                key={virtualArea.id}
                                className="main-area-card"
                                role={canEditAreas ? 'button' : undefined}
                                tabIndex={canEditAreas ? 0 : undefined}
                                onClick={() => {
                                    if (canEditAreas) {
                                        setSelectedVirtualArea(virtualArea);
                                    }
                                }}
                            >
                                <span className="main-area-card__icon">
                                    <AutoStoriesTwoToneIcon />
                                </span>
                                <div className="main-area-card__text">
                                    <div className="main-area-card__title">
                                        <span className="main-area-card__name">{virtualArea.name}</span>
                                        {Boolean(virtualArea.code) && <Pill tone="neutral" label={virtualArea.code} />}
                                    </div>
                                    <span className="main-area-card__areas">
                                        {virtualArea.areas.map((area: IRestaurantArea) => area.name).join(', ')}
                                    </span>
                                </div>
                                <div className="main-area-card__seats">
                                    <span className="main-area-card__seats__value">{seats}</span>
                                    <span className="main-area-card__seats__label">{t('sectors.seatsLabel')}</span>
                                </div>
                            </div>
                        );
                    })}
            </div>
            {canEditAreas && <VirtualAreaView virtualArea={selectedVirtualArea} onClose={onVirtualAreaViewClose} />}
        </div>
    );
};

export default VirtualAreas;
